import { DisplayFormattedDate } from 'components/common';
import { format } from 'date-fns';
import { useReduxState } from 'hooks';
import { dateFnsLocales } from 'shared-locales';

interface Props {
  startDate: string;
  useMonthSpecifier?: boolean;
}

const CalendarEventDateIcon = ({
  startDate,
  useMonthSpecifier = false
}: Props) => {
  const { language, theme } = useReduxState();

  return (
    <div className="icon">
      <div className="icon-number">
        <DisplayFormattedDate date={startDate} dateFormat="dd" />
      </div>
      <div className="icon-specifier">
        <DisplayFormattedDate
          date={startDate}
          dateFormat={useMonthSpecifier ? 'MMM' : 'EEEEEE'}
          dateFormatOptions={{ locale: dateFnsLocales[language] }}
        />
      </div>

      <style jsx>{`
        .icon {
          align-items: center;
          background-color: ${theme.lightGrey};
          border-radius: 7px;
          color: ${theme.textColorLight};
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          font-size: 1rem;
          font-weight: 700;
          justify-content: center;
          padding-top: 3px;
          width: 40px;
          height: 40px;
        }
        .icon-number {
          line-height: 0.7;
          font-size: 1.8rem;
        }
        .icon-specifier {
          color: ${theme.textColorLighter};
          font-size: 1.2rem;
          font-weight: 600;
          text-transform: capitalize;
        }
      `}</style>
    </div>
  );
};

export default CalendarEventDateIcon;
